export default __webpack_public_path__ + "static/media/elevate-bpn-poster-2.8dee5be1.jpg";